import { render } from "./TipSplitDetail.vue?vue&type=template&id=6b4d82e9&scoped=true"
import script from "./TipSplitDetail.vue?vue&type=script&lang=js"
export * from "./TipSplitDetail.vue?vue&type=script&lang=js"

import "./TipSplitDetail.vue?vue&type=style&index=0&id=6b4d82e9&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b4d82e9"]])

export default __exports__